export const Constants = {
  Cookies: {
    COOKIE_NAME: 'fitassistant',
    PER_CATEGORY_COOKIE_NAME: 'fitassistantpercategory',
  },

  Events: {
    MOUNTING_OPTION_IMAGE_LOAD: 'mountingOptionImageLoad',
    VARIATION_OPTION_IMAGE_LOAD: 'variationOptionImageLoad',
  },

  FitTipClassifications: {
    VEHICLE_SPECIFIC: 'VehicleSpecific',
  },

  SolutionTypes: {
    PLATFORM: 'SolutionPlatform',
  },

  QueryParameters: {
    SOLUTION_ID: 'solutionId',
  },

  Tracking: {
    CHOOSE_ROOF_RACK: 'fit_assistant_choose_RSS_for_RTT',
    FIND_ROOF_RACK: 'fit_assistant_find_RRS_for_RTT',
    CHOOSE_VARIATION: 'fit_assistant_choose_carvariation',
    CHOOSE_YEAR: 'fit_assistant_choose_year',
    CHOOSE_VARIATION_1: 'fit_assistant_choose_carvariation1',
    CLOSE_CONFIRMATION: 'fit_assistant_close_confirmation',
    CLOSE_NOFIT: 'fit_assistant_close_nofit',
    CLOSE_UNCONFIRMED: 'fit_assistant_close_unconfirmed',
    CLOSE_CONFIRMED: 'fit_assistant_close_confirmed',
    CLOSE_CONFIRMED_NO_RACKS: 'fit_assistant_close_confirmed_noRSS',
    EXIT: 'fit_assistant_exit',
    OK: 'fit_assistant_OK',
    RESET: 'fit_assistant_reset',
    OPEN_WITH_SELECTION: 'fit_assistant_open_value',
    OPEN_WITHOUT_SELECTION: 'fit_assistant_open_empty',
    VIEW: 'fit_assistant_view',
    CAR_VARIATION_1: {
      RACK_MOUNTED: 'On Roof racks or Truck bed racks',
      DIRECT_ON_VEHICLE: 'Direct on vehicle',
    },
  },
  WCAG: {
    FIRST_TABABLE: '#REACT_FitAssistant_new button:not(.invisible)',
    LAST_TABABLE: '#REACT_FitAssistant_new a, #REACT_FitAssistant_new button',
  },
};
